import { NgModule } from '@angular/core'
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core'
import {CHECKOUT_FEATURE, CheckoutRootModule} from '@spartacus/checkout/base/root';
import {checkoutTranslationChunksConfig, checkoutTranslations} from '@spartacus/checkout/base/assets';

@NgModule({
  imports: [
    CheckoutRootModule
  ],
  providers: [
    provideConfig(
      {
        featureModules: {
          [CHECKOUT_FEATURE]: {
            module: () =>
              import('@spartacus/checkout/base').then((m) => m.CheckoutModule),
          },
        }
      } as CmsConfig
    ),
    provideConfig(
      {
        i18n: {
          resources: checkoutTranslations,
          chunks: checkoutTranslationChunksConfig,
        },
      } as I18nConfig
    )
  ]
})
export class CheckoutFeatureModule {
}
